/**
 * @Author: Nenad Brcic
 * @Date: 26.05.16
 * @Email: neno@neno.ch
 */

import React, {Component} from 'react';
import Icon from '../../shared/Icon';
import CSSModules from 'react-css-modules';
import styles from './SearchForm.scss';
import settings from '../../../../config/settings';
import env from '../../../../config/env';


class SearchForm extends Component {
    constructor(props) {
        super(props);
        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    }

    componentDidMount() {
        this.clearSearchButton = document.getElementsByClassName(`search-field-clear`)[0];
    }

    handleSearch(e) {
        e.preventDefault();
        this.props.handleSearch(this.refs.query.value);
    }

    resetSearch () {
        this.refs.query.value = '';
    }

    handleSearchInputChange() {
        if(!!this.refs.query.value) {
            this.clearSearchButton.style.visibility = 'visible';
        } else {
            this.clearSearchButton.style.visibility = 'hidden';
        }
        this.render();
    }

    render() {
        const className = settings.search.fields.className ? settings.search.fields.className : '';

        return (
            <div styleName="wrapper">
                <form onSubmit={ (e) => this.handleSearch(e) }>
                    <fieldset>
                        <div styleName="search-form" className={ className }>
                            <i styleName="search-icon" className={ className }>
                                <Icon styleName="search-icon-ico" icon={settings.search.fields.icon} />
                            </i>
                            <input
                                id={settings.search.fields.simple}
                                styleName="search-field"
                                className={ className }
                                placeholder={ this.props.placeholderText }
                                ref="query"
                                type={ env.domain === 'SD' ? 'tel' : 'search' }
                                disabled={ !!this.props.disabled ? "disabled" : null }
                                onChange={ () => this.handleSearchInputChange() }
                                pattern={!!settings.search.fields.pattern ? settings.search.fields.pattern : null}
                                maxLength={!!settings.search.fields.maxLength ? settings.search.fields.maxLength : null}
                            />
                            <button type="button"
                                    className={ `search-field-clear ${ className}` }
                                    styleName="search-clear"
                                    style={{visibility: 'hidden'}}
                                    onClick={ () => {
                                        this.resetSearch(true);
                                        this.handleSearchInputChange();
                                    }}
                            >
                                <Icon styleName="icon-close" icon="Vitra_Close.svg" />
                            </button>
                            <button styleName="search-button"
                                    className={ className }
                                    type="submit"
                            >
                                <Icon styleName="search-button-ico" icon="Vitra_Next.svg" />
                            </button>
                        </div>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default CSSModules(SearchForm, styles);


// WEBPACK FOOTER //
// ./app/components/Main/SearchForm/index.jsx